import React, { useState } from "react";
import ConfirmModal from "../ConfirmModal";
import { updateReportState } from "../../api/api";
import { renderStatusBadge } from "../../pages/AllReports";

export const ReportStateToggle = ({ report, onStateChange, requireConfirm = false }) => {
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // Local state initialized from prop
  const [localState, setLocalState] = useState(report.state);

  // Determine the new state on toggle
  const newState = localState === "ready" ? "draft" : "ready";

  const toggleState = async () => {
    setShowConfirm(false);
    setLoading(true);

    // Optimistically update local state
    setLocalState(newState);
    onStateChange(report.id, newState);

    try {
      await updateReportState(report.id, newState);
    } catch (err) {
      console.error("Failed to update report state", err);
      // Revert on failure
      setLocalState(report.state);
      onStateChange(report.id, report.state);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (loading) return;
    if (requireConfirm) setShowConfirm(true);
    else toggleState();
  };

  return (
    <>
      <span
        className="report-state-toggle"
        onClick={handleClick}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          gap: "0.25rem", // smaller gap between badge and icon
        }}
      >
        {/* Status badge to the left */}
        {renderStatusBadge(localState)}

        {/* Icon */}
        {localState !== "ready" ? (
          <i
            className="bi bi-shield-fill-exclamation text-warning fs-4"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Merkitse raportti valmiiksi"
            style={{ textShadow: "0 0 3px rgba(0,0,0,1.5)" }}
          />
        ) : (
          <i
            className="bi bi-shield-fill-check text-success fs-4"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Merkitse raportti keskeneräiseksi"
            style={{ textShadow: "0 0 3px rgba(0,0,0,1.5)" }}
          />
        )}
      </span>

      {requireConfirm && (
        <ConfirmModal
          show={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={toggleState}
          title="Vahvista muutos"
          message={`Haluatko merkitä raportin "${report.name}" ${
            localState === "ready" ? "keskeneräiseksi" : "valmiiksi"
          }?`}
          confirmText="Kyllä, jatka"
          cancelText="Peru"
          confirmVariant="success"
        />
      )}
    </>
  );
};